import {
    getAriaControlsElement,
    getAriaControlsElements,
    getAriaExpanded,
    setAriaExpanded,
} from "./base";

export function isMenuButton(element: HTMLElement): element is HTMLButtonElement {
    if (element instanceof HTMLButtonElement &&
        element.hasAttribute("aria-controls") &&
        element.hasAttribute("aria-expanded")) {
        const menu = getAriaControlsElement(element);
        return menu instanceof HTMLElement && menu.role === "menu";
    } else {
        return false;
    }
}

export function toggleMenu(menuButton: HTMLButtonElement) {
    if (getAriaExpanded(menuButton)) {
        setAriaExpanded(menuButton, false);
        hideControlsRegions(menuButton);

        document.body.removeAttribute("data-menu-expanded");
    } else {
        setAriaExpanded(menuButton, true);

        let autofocusTarget: HTMLElement | undefined = undefined;
        for (const region of getAriaControlsElements(menuButton)) {
            region.removeAttribute("hidden");

            if (typeof autofocusTarget === "undefined") {
                const found = region.querySelector("input,select,textarea,button,a,[tabindex]");
                if (found instanceof HTMLElement) {
                    autofocusTarget = found;
                }
            }
        }

        if (typeof autofocusTarget !== "undefined") {
            setTimeout(() => autofocusTarget.focus(), 0);
        }

        document.body.setAttribute("data-menu-expanded", "");
    }
}

export function hideAllMenus() {

    const buttons = document.querySelectorAll("button[aria-controls][aria-expanded]");
    for (const button of buttons) {
        if (button instanceof HTMLElement && isMenuButton(button)) {
            setAriaExpanded(button, false);
            hideControlsRegions(button);
        }
    }

    document.body.removeAttribute("data-menu-expanded");
}

function hideControlsRegions(button: HTMLButtonElement) {
    const focusedElement = document.activeElement;
    for (const region of getAriaControlsElements(button)) {
        region.hidden = true;

        if (focusedElement !== null && region.contains(focusedElement)) {
            button.focus();
        }
    }
}
